<ng-container *ngIf="isEnabledByBookingType">
  <ng-container *ngIf="isPayment; else isFreeBannerContent">
    <ng-container *ngTemplateOutlet="isPaymentBannerContent"></ng-container>
  </ng-container>
</ng-container>

<ng-template #isPaymentBannerContent>
  <div class="chubb-banner-cont">
    <div class="header-cont payment">
      <img alt="CHUBB_LOGO" class="img-logo" loading="lazy" [src]="CHUBB_LOGO | baseImage: CHUBB_BOOKING_IMAGES_BASE_PATH">
      <div class="info">
        <div class="promo" *ngIf="hasDiscount">
          <span class="promo-percentage">{{ 'HOTELS_MODULE.RESULT_HOTELS.OFF' | transloco: { percentage: discountPercentage } }}</span>
          <span class="price-strike">{{ priceWithoutDiscount | currencyFormat : currencyCode }}</span>
        </div>
        <span class="price">{{paymentPrice}}</span>
        <div *ngIf="hasDaysAndTravelers" class="days-travelers-info">
          <p>{{ stayAndTravelersLabel }}</p>
        </div>
      </div>
    </div>
    <div class="ext-cont payment">
      <ul class="body-cont payment">
        <ng-container *ngFor="let highlighted of assistanceHighlighted; trackBy: trackBy; let last = last;">
          <li>
            <p>
              {{ highlighted.Text }} {{ highlighted.Amount | currencyFormat: highlighted.CurrencyCode }}
            </p>
          </li>
          <li *ngIf="isInsuredSumVariesAge(last)">
            <p>{{ assetChubbBookingBanner?.ASSISTANCE?.INSURED_SUM_VARIES_AGE }}</p>
          </li>
        </ng-container>
      </ul>
      <div class="lateral-banner" *ngIf="!!lateralBanner">
        <img alt="lateralBanner" class="img-lateral" loading="lazy" [src]="lateralBanner | baseImage: CHUBB_BOOKING_IMAGES_BASE_PATH">
      </div>
    </div>
    <hr class="bottom-header">
    <div class="footer-cont-payment">
      <div class="flex" (click)="showPaymentOfferDetailsEvent()">
        <p>{{ assetChubbBookingBanner?.ASSISTANCE?.FOOTER_BANNER_MESSAGE }}</p>
        <i aria-hidden="true" class="icon-expand"></i>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #isFreeBannerContent>
  <div class="section-title">
    <h3>{{assetChubbBookingBanner.SECTION_TITLE}}</h3>
  </div>
  <div class="chubb-banner-cont">
    <div class="header-cont">
      <span>{{assetChubbBookingBanner.TITLE}}</span>
      <img alt="CHUBB_LOGO"  class="img-logo" loading="lazy" [src]="CHUBB_LOGO | baseImage: CHUBB_BOOKING_IMAGES_BASE_PATH">
    </div>
    <div class="ext-cont">
      <div class="lateral-banner" *ngIf="!!lateralBanner">
        <img alt="lateralBanner" class="img-lateral" loading="lazy" [src]="lateralBanner | baseImage: CHUBB_BOOKING_IMAGES_BASE_PATH">
      </div>
      <div class="body-cont">
        <ng-container *ngFor="let option of options; first as isFirst">
          <div class="row-option" [class.first]="isFirst">
            <img class="img-check" loading="lazy" [src]="CHUBB_CHECK | baseImage: CHUBB_BOOKING_IMAGES_BASE_PATH">
            <span>{{option}}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="!isEnabledGiftPrimeTag">
          <div class="sub-title-welcome-card">
            <div class="cont-card">
              <img class="img-welcome" loading="lazy" [src]="CHUBB_WELCOME | baseImage: CHUBB_BOOKING_IMAGES_BASE_PATH">
              <span>{{assetChubbBookingBanner.SUB_TITLE}}</span>
            </div>
          </div>
        </ng-container>
        <div class="footer-cont">
          <ng-container *ngIf="isEnabledGiftPrimeTag">
            <app-chubb-prime-gift
              [isInternationalTrip]="isInternationalTrip">
            </app-chubb-prime-gift>
          </ng-container>
          <div *ngIf="hasDaysAndTravelers" class="days-travelers-info">
            <span>{{ stayAndTravelersLabel }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>